export default "__VITE_ASSET__DGo3o0uw__"